import { Component, OnInit } from '@angular/core';
import { Temoignage } from '../../models/temoignage.model';
import { TemoignageService } from '../../services/temoignage.service';
import { JournalService } from '../../services/journal.service';

@Component({
  selector: 'app-gestion-temoignages',
  templateUrl: './gestion-temoignages.component.html',
  styleUrls: ['./gestion-temoignages.component.css']
})
export class GestionTemoignagesComponent implements OnInit {

  temoignages: Temoignage[] = [];
  filtreStatut: string = '';

  formulaireOuvert = false;
  nouveauTemoignage: Temoignage = { auteur: '', lieu: '', contenu: '', note: 5, statut: 'approuve' };

  constructor(
    private temoignageService: TemoignageService,
    private journalService: JournalService
  ) { }

  ngOnInit(): void {
    this.charger();
  }

  get nombreEnAttente(): number {
    return this.temoignages.filter(t => t.statut === 'attente').length;
  }

  ajouterManuel(): void {
    if (!this.nouveauTemoignage.auteur || !this.nouveauTemoignage.lieu || !this.nouveauTemoignage.contenu) return;
    this.temoignageService.creerParAdmin(this.nouveauTemoignage).subscribe(() => {
      this.charger();
      this.journalService.ajouter(`Témoignage de ${this.nouveauTemoignage.auteur} ajouté manuellement.`).subscribe();
      this.nouveauTemoignage = { auteur: '', lieu: '', contenu: '', note: 5, statut: 'approuve' };
      this.formulaireOuvert = false;
    });
  }

  charger(): void {
    this.temoignageService.getAll().subscribe(data => {
      this.temoignages = data;
    });
  }

  get temoignagesFiltres(): Temoignage[] {
    if (!this.filtreStatut) return this.temoignages;
    return this.temoignages.filter(t => t.statut === this.filtreStatut);
  }

  approuver(t: Temoignage): void {
    if (t.id === undefined) return;
    this.temoignageService.changerStatut(t.id, 'approuve').subscribe(() => {
      this.charger();
      this.journalService.ajouter(`Témoignage de ${t.auteur} approuvé.`).subscribe();
    });
  }

  rejeter(t: Temoignage): void {
    if (t.id === undefined) return;
    this.temoignageService.changerStatut(t.id, 'rejete').subscribe(() => {
      this.charger();
      this.journalService.ajouter(`Témoignage de ${t.auteur} rejeté.`).subscribe();
    });
  }

  supprimer(t: Temoignage): void {
    if (t.id === undefined) return;
    if (confirm('Supprimer ce témoignage ?')) {
      this.temoignageService.supprimer(t.id).subscribe(() => this.charger());
    }
  }

  etoiles(note: number): string {
    return '★'.repeat(note) + '☆'.repeat(5 - note);
  }
}
